<template>
  <div class="game-page">
    <div
      v-if="url"
      ref="backFab"
      class="game-back-fab"
      role="button"
      aria-label="返回首页"
      @click="onBackFabClick"
      @mousedown="onBackFabPointerDown"
      @touchstart="onBackFabPointerDown"
    >
      <i class="van-icon van-icon-wap-home game-back-fab__icon" aria-hidden="true"></i>
      <span class="game-back-fab__text">返回</span>
    </div>
    <div v-if="url" class="game-iframe-wrap">
      <iframe ref="iframe" class="game-iframe" scrolling="auto" frameborder="0" id="iframe" />
    </div>
  </div>
</template>
<script>
export default {
  name: 'gamePage',
  inject: { appHost: { default: null } },
  data() {
    return {
      url: null,
      hasRendered: false,
      backFabStyle: {
        top: null,
        left: null,
      },
      backFabDragState: {
        dragging: false,
        moved: false,
        startX: 0,
        startY: 0,
        offsetX: 0,
        offsetY: 0,
      },
    };
  },
  watch: {
    $route: {
      handler(to) {
        this.onRouteQuery(to);
      },
      deep: true,
    },
  },
  created() {
    this.onRouteQuery(this.$route);
  },
  methods: {
    resetBackFabPosition() {
      this.backFabStyle.top = null;
      this.backFabStyle.left = null;
      this.backFabDragState.dragging = false;
      this.backFabDragState.moved = false;

      if (this.$refs.backFab) {
        this.$refs.backFab.style.top = '';
        this.$refs.backFab.style.left = '';
        this.$refs.backFab.style.right = '';
      }
    },
    getPointFromEvent(e) {
      if (e.touches && e.touches.length) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
      if (e.changedTouches && e.changedTouches.length) {
        return { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
      }
      return { x: e.clientX, y: e.clientY };
    },
    onBackFabClick() {
      if (this.backFabDragState.moved) {
        this.backFabDragState.moved = false;
        return;
      }
      this.goHome();
    },
    onBackFabPointerDown(e) {
      if (!this.$refs.backFab) return;
      const point = this.getPointFromEvent(e);
      const fabRect = this.$refs.backFab.getBoundingClientRect();

      this.backFabDragState.dragging = true;
      this.backFabDragState.moved = false;
      this.backFabDragState.startX = point.x;
      this.backFabDragState.startY = point.y;
      this.backFabDragState.offsetX = point.x - fabRect.left;
      this.backFabDragState.offsetY = point.y - fabRect.top;

      document.addEventListener('mousemove', this.onBackFabPointerMove);
      document.addEventListener('mouseup', this.onBackFabPointerUp);
      document.addEventListener('touchmove', this.onBackFabPointerMove, { passive: false });
      document.addEventListener('touchend', this.onBackFabPointerUp);
      document.addEventListener('touchcancel', this.onBackFabPointerUp);
    },
    onBackFabPointerMove(e) {
      if (!this.backFabDragState.dragging || !this.$refs.backFab) return;

      if (e.cancelable) {
        e.preventDefault();
      }
      const point = this.getPointFromEvent(e);
      const fabRect = this.$refs.backFab.getBoundingClientRect();
      const width = fabRect.width;
      const height = fabRect.height;
      const maxLeft = Math.max(window.innerWidth - width, 0);
      const maxTop = Math.max(window.innerHeight - height, 0);
      const nextLeftRaw = point.x - this.backFabDragState.offsetX;
      const nextTopRaw = point.y - this.backFabDragState.offsetY;
      const nextLeft = Math.min(Math.max(nextLeftRaw, 0), maxLeft);
      const nextTop = Math.min(Math.max(nextTopRaw, 0), maxTop);

      if (!this.backFabDragState.moved) {
        const movedX = Math.abs(point.x - this.backFabDragState.startX);
        const movedY = Math.abs(point.y - this.backFabDragState.startY);
        this.backFabDragState.moved = movedX > 4 || movedY > 4;
      }

      this.backFabStyle.left = nextLeft;
      this.backFabStyle.top = nextTop;
      this.applyBackFabPosition();
    },
    onBackFabPointerUp() {
      this.backFabDragState.dragging = false;
      document.removeEventListener('mousemove', this.onBackFabPointerMove);
      document.removeEventListener('mouseup', this.onBackFabPointerUp);
      document.removeEventListener('touchmove', this.onBackFabPointerMove);
      document.removeEventListener('touchend', this.onBackFabPointerUp);
      document.removeEventListener('touchcancel', this.onBackFabPointerUp);
    },
    applyBackFabPosition() {
      if (!this.$refs.backFab) return;
      if (this.backFabStyle.top !== null) {
        this.$refs.backFab.style.top = `${this.backFabStyle.top}px`;
      }
      if (this.backFabStyle.left !== null) {
        this.$refs.backFab.style.left = `${this.backFabStyle.left}px`;
      }
      this.$refs.backFab.style.right = 'auto';
    },
    onRouteQuery(route) {
      const that = this;
      const q = route.query;
      that.resetBackFabPosition();
      that.url = null;
      that.hasRendered = false;

      if (q.dailiD == 1) {
        that.getAgentLoginUrl();
        return;
      }
      if (q.dailiD == 2) {
        that.getservicerurl();
        return;
      }
      if (q.app == 1) {
        const downloadUrl = that.$store.state.appInfo.ios_download_url;
        if (downloadUrl) {
          window.location.href = downloadUrl;
        } else if (that.getAppHost() && that.getAppHost().showTost) {
          that.getAppHost().showTost(0, '下载地址未配置');
        }
        return;
      }
      if (!q.name) {
        return;
      }

      const platformName = String(q.name).trim();
      const gameTypeParam = q.type !== undefined && q.type !== '' ? q.type : 0;
      const gameCodeParam = q.code != null && q.code !== '' ? String(q.code) : '';
      const skipPreEntry = q.skipPreEntry == 1 || q.skipPreEntry === '1' || q.skipPreEntry === true;
      const ts = that.$store.state.userInfo && that.$store.state.userInfo.transferstatus;

      if (ts === 1) {
        that.goGamePage(platformName, gameTypeParam, gameCodeParam);
        return;
      }
      if (skipPreEntry) {
        that.goGamePage(platformName, gameTypeParam, gameCodeParam);
        return;
      }
      // 直链 /gamePage 且无 skip：回当前栈大厅并在 App 根层弹层（由 openGame 进入时已在大厅弹过）
      const host = that.getAppHost();
      if (host && host.openGamePreEntryFromGameRoute) {
        host.openGamePreEntryFromGameRoute({
          name: platformName,
          type: gameTypeParam,
          code: gameCodeParam,
          venueTitle: q.venueTitle,
        });
      }
      that.$router.replace('/');
    },
    getAppHost() {
      return this.appHost || (this.$parent && this.$parent.showTost ? this.$parent : null);
    },
    goHome() {
      const host = this.getAppHost();
      const finish = () => {
        if (host && host.goNav) {
          host.goNav('/');
        } else {
          this.$router.replace('/');
        }
      };
      if (host && host.showLoading) {
        host.showLoading();
      }
      const refreshMoney = this.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        if (res && res.code == 200 && res.data) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          this.$store.commit('changUserInfo');
        }
      });
      const refreshVenues = this.$apiFun.post('/api/balancelist', {});
      Promise.all([refreshMoney.catch(() => {}), refreshVenues.catch(() => {})])
        .finally(() => {
          if (host && host.hideLoading) {
            host.hideLoading();
          }
          finish();
        });
    },
    // 打开客服
    getservicerurl() {
      let that = this;
      that.$apiFun.post('/api/getservicerurl', {}).then(res => {
        if (res.code != 200) {
          that.getAppHost() && that.getAppHost().showTost(0, res.message);
        }
        if (res.code == 200) {
          const content = String((res.data && res.data.url) || '').trim();
          if (!content) {
            that.getAppHost() && that.getAppHost().showTost(0, '客服链接未配置');
            return;
          }
          if (/^https?:\/\//i.test(content)) {
            window.location.href = content;
            return;
          }
          that.url = content;
          that.hasRendered = false;
        }
      });
    },
    // 打开代理
    getAgentLoginUrl() {
      let that = this;
      that.$apiFun.get('/api/getAgentLoginUrl', {}).then(res => {
        if (res.code != 200) {
          that.getAppHost() && that.getAppHost().showTost(0, res.message);
        }
        if (res.code == 200) {
          that.url = res.data.url;
        }
      });
    },
    // 打开游戏
    goGamePage(name, type, code) {
      let that = this;
      that.$apiFun
        .post('/api/getGameUrl', { plat_name: name, game_type: type || 0, game_code: code, is_mobile_url: 1 })
        .then(res => {
          if (res.code != 200) {
            that.getAppHost() && that.getAppHost().showTost(0, res.message);
          }
          if (res.code == 200) {
            that.url = res.data.url;
            that.hasRendered = false;
          }
        })
        .catch(() => {});
    },
    renderIframeContent() {
      let that = this;
      if (that.hasRendered || !that.url || !that.$refs.iframe) return;

      const iframe = that.$refs.iframe;
      const content = String(that.url).trim();
      const isHttpUrl = /^https?:\/\//i.test(content);

      if (isHttpUrl) {
        try {
          iframe.contentWindow.location.replace(content);
        } catch (e) {
          iframe.src = content;
        }
        that.hasRendered = true;
        return;
      }

      try {
        const doc = iframe.contentWindow.document;
        doc.open();
        doc.write(content);
        doc.close();
        that.hasRendered = true;
      } catch (e) {
        that.getAppHost() && that.getAppHost().showTost(0, '页面加载失败');
      }
    },
  },
  updated() {
    this.renderIframeContent();
    this.applyBackFabPosition();
  },
  beforeDestroy() {
    this.onBackFabPointerUp();
  },
};
</script>

<style lang="scss" scoped>
.game-iframe-wrap {
  height: 100vh;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
.game-iframe {
  display: block;
  height: 100%;
  width: 100%;
  border: 0;
}
.game-back-fab {
  position: fixed;
  top: calc(52px + env(safe-area-inset-top, 0px));
  right: 10px;
  z-index: 10000;
  touch-action: none;
  user-select: none;
  min-height: 48px;
  padding: 0 16px 0 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.45);
  background: linear-gradient(145deg, #7dd3fc 0%, #38bdf8 38%, #0ea5e9 78%, #0284c7 100%);
  box-shadow:
    0 2px 4px rgba(2, 132, 199, 0.35),
    0 8px 20px rgba(2, 132, 199, 0.4);
  .game-back-fab__icon {
    font-size: 18px;
    color: #fff;
    flex-shrink: 0;
  }
  .game-back-fab__text {
    font-size: 16px;
    color: #fff;
    line-height: 1;
    font-weight: 500;
    letter-spacing: 0.02em;
    text-shadow: 0 1px 1px rgba(0, 80, 120, 0.35);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mode/gamePage.vue